import { createStyles, makeStyles } from "@material-ui/core";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { Grid, Typography } from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import React, { useEffect, useState } from "react";
import { useMutation, useQueryClient } from "react-query";
import { connect, useSelector } from "react-redux";
import { useHistory, withRouter } from "react-router-dom";
import { WORK_FLOW_TYPE } from "../../config/cacheKey";
import {
  GetCartableActionsResponse,
  GetCoreInformationResponse,
  GetSupplierInformationResponse,
  PaginationInfo,
  ReferenceKey,
  supplierCredits,
  supplierUsers,
} from "../../models/cartable.model";
import { ApiResultModel, ColumnModel } from "../../models/common.model";
import {
  GetInstallmentTableRequest,
  GetInstallmentTableResponse,
} from "../../models/loan.model";
import {
  GetAppInformation,
  GetCartableActions,
  GetSupplierInformation,
} from "../../services/cartable.service";
import ActionTabs from "./actionCopmonets.tsx/actionTab/actionTabs";
import HeaderInfo from "./headerInfo";
import CheckIcon from "@mui/icons-material/Check";

const columns: readonly ColumnModel[] = [
  { id: "requestorUserTitle", label: "کاربر درخواست دهنده" },
  { id: "requestDatePersian", label: "تاریخ درخواست" },
  { id: "loanTemplateTitle", label: "طرح فروش" },

  {
    id: "amount",
    label: "مبلغ  (ریال)",
    hasFormat: true,
    format: (value: number) => {
      return value.toLocaleString("fa");
    },
  },
  { id: "creditStatusTitle", label: "وضعیت" },
];
const useStyles = makeStyles((theme) =>
  createStyles({
    select: {
      "&.Mui-selected": {
        backgroundColor: muiSelected,
      },
    },
  })
);
let muiSelected: any;
const columnsActivation: readonly ColumnModel[] = [
  { id: "firstName", label: "نام کاربر" },
  { id: "lastName", label: "نام خانوادگی کاربر" },
  { id: "mobileNumber", label: "شماره موبایل" },
  { id: "createDate_Persian", label: "تاریخ درخواست" },
  { id: "isSuperUser", label: "دسترسی کامل" },
];
interface supplierInfoDetail {
  id: string | null;
  requestDetail: GetSupplierInformationResponse | undefined;
  reload: boolean;
}

function _detailPage({ id, requestDetail, reload }: supplierInfoDetail) {
  useEffect(() => {}, [reload]);
  const jsonFile = useSelector((state: any) => state.style);

  muiSelected = jsonFile?.muiSelected;
  return (
    <div
      // className="cardDetail "
      style={{ background: "#F9F6F7", padding: "2px !important" }}
    >
      <div style={{ background: "#F9F6F7", padding: "1rem" }}>
        <Grid
          container
          xs={12}
          columns={{ xs: 4, sm: 8, md: 12 }}
          style={{ backgroundColor: "#F9F6F7" }}
        >
          <Grid item xs={3} sm={6} md={3}>
            <Typography className=" " style={{ marginLeft: "2vh" }}>
              <AccountCircleIcon
                style={{ width: "46px", height: "46px", color: "#9AAFC4" }}
              />
              <span className="detailPageTitle" style={{ marginRight: "1vh" }}>
                {requestDetail?.title}
              </span>
            </Typography>
          </Grid>
          <Grid item xs={3} sm={6} md={3}>
            <Typography
              className=" "
              style={{ marginLeft: "2vh", marginTop: "1.8vh" }}
            >
              {/* <b className="detailPageTitle">کد ملی: </b> */}
              <span className="detailPageTitle">
                {requestDetail?.isTopRated}
              </span>
            </Typography>
          </Grid>
          <Grid item xs={3} sm={6} md={4}>
            <Typography
              className=" "
              style={{
                marginLeft: "2vh",
                marginTop: "1.8vh",
                whiteSpace: "nowrap",
              }}
            >
              <b className="detailPageTitle"> آخرین وضعیت: </b>
              <span className="detailPageTitle">
                {requestDetail?.supplierStatusTitle}
              </span>
            </Typography>
          </Grid>
        </Grid>
      </div>
    </div>
  );
}

function SuppliersRequirementsDetail({ cartable }: DetailPagePropsInterface) {
  const [showInstallmentComponent, setShowInstallmentComponent] = useState(
    false
  );
  const [isCore, setIsCore] = useState(true);
  const queryClient = useQueryClient();
  let getCartableAction: string;
  getCartableAction = queryClient.getQueryData(WORK_FLOW_TYPE)!;

  if (getCartableAction === null || getCartableAction === undefined) {
    getCartableAction = localStorage.getItem("setActivePage")!;
  }
  const history = useHistory<{
    id: string;
    pageNumber: number;
    clickOnBack: boolean;
  }>();
  const [flagActionTabs, setFlagActionTab] = useState(false);

  const [actionTabsData, setActionTabData] = useState();

  const [suppliersInfo, setSuppliersInfo] = useState<
    GetSupplierInformationResponse
  >();
  const [reload, setReload] = useState(false);

  // const id =
  //   history.location.state !== undefined
  //     ? history.location.state.id
  //     : window.sessionStorage.getItem("id") !== undefined
  //     ? window.sessionStorage.getItem("id")
  //     : null;

  const id = localStorage.getItem("SUPPLIER_ID");
  const [pageNumber, setPageNumber] = useState(
    history.location.state !== undefined ? history.location.state.pageNumber : 1
  );
  const requestPanelTabs = new ReferenceKey();
  const workFlowType = queryClient.getQueryData(WORK_FLOW_TYPE)!;
  // requestPanelTabs.referenceKey = String(id);
  // requestPanelTabs.referenceKey = "ce104763-7e3a-4cc5-b5c5-2037b89e52ff";

  // if (performance.navigation.type === 1) {

  // (history.action === "REPLACE" && history.location.state !== undefined && history.location.state.id){
  //   id = history.location.state.id;
  // }
  if (id === undefined || id == null) {
    history.push(`/loan/${cartable.cartable}`);
    queryClient.setQueryData(WORK_FLOW_TYPE, workFlowType);
    // history.push("/loan/loan-list");
  }
  const [dataGetCoreInformation, setDataGetCoreInformation] = useState<
    GetCoreInformationResponse
  >();

  const [dataGetInstallmentTable, setDataGetInstallmentTable] = useState<
    GetInstallmentTableResponse
  >();
  const [dataGetInstallmentCheque, setDataGetInstallmentCheque] = useState();
  const [returnPageRef, setReturnPageRef] = useState(null);
  const request = new GetInstallmentTableRequest();

  //***GetAppInformation */
  const {
    mutateAsync: getAppInformationMutation,
    isLoading: isMutatinApp,
  } = useMutation(GetAppInformation, {
    onSuccess: (data: ApiResultModel<GetCoreInformationResponse>) => {
      if (data.isSuccess) {
        setDataGetCoreInformation(data.data);
        // history.push("/loan/SupplierSettlementCartable");
      } else {
        history.push("/loan/CustomerRegistration");
      }
    },
  });

  const { mutate: GetSupplierInformationMutate, isLoading } = useMutation(
    GetSupplierInformation,
    {
      onSuccess: (data: GetSupplierInformationResponse) => {
        if (data) {
          setSuppliersInfo(data);
        }
      },
      onError: () => {},
    }
  );

  useEffect(() => {
    GetSupplierInformationMutate({
      supplierId: Number(id),
    });
    setReload(false);
  }, [reload]);

  useEffect(() => {
    if (id) {
      if (
        cartable.cartable === "SupplierRequirements" ||
        getCartableAction === "SupplierRequirements"
        // cartable.cartable === "LoanRegistrationBySupplier" ||
        // getCartableAction === "LoanRegistrationBySupplier"
      ) {
        // getCoreInformationMutation(requestPanelTabs);
        setIsCore(true);
      } else if (
        cartable.cartable === "CustomerRegistration" ||
        getCartableAction === "CustomerRegistration"
      ) {
        getAppInformationMutation(requestPanelTabs);
        setIsCore(false);
        // getInstallmentTableMutation(request);
      }
    }
  }, []);

  //*** */
  const [dataGetCartableActions, setDataGetCartableActions] = useState<
    GetCartableActionsResponse[]
  >();
  //*** */
  const {
    mutateAsync: getCartableActionsMutation,
    isLoading: isMutatinCartable,
  } = useMutation(GetCartableActions, {
    onSuccess: (data: GetCartableActionsResponse[]) => {
      if (data) {
        setDataGetCartableActions(data);
        // history.push("/loan/SupplierSettlementCartable");
      }
    },
  });

  useEffect(() => {
    return () => {
      // && history.location.pathname === "any specific path")

      if (history.action === "POP") {
        history.replace({
          pathname: history.location.pathname,
          state: { id: "", pageNumber: pageNumber, clickOnBack: true },
        });
      }
    };
  }, [history]);

  useEffect(() => {
    if (id) {
      getCartableActionsMutation({
        // workflowType: getCartableAction!,
        // referenceKey: id ?? "",
        workflowType: "SupplierRequirements",
        referenceKey: id ?? "",
      });
    }
  }, []);

  const child = (
    <_detailPage id={id} requestDetail={suppliersInfo} reload={reload} />
  );

  // if (isMutatinApp || isMutatinCore || isMutatinCartable) {
  //   return (
  //     <div>
  //       <Backdrop
  //         hidden={false}
  //         open={true}
  //         sx={{ color: "#fff", zIndex: () => 1 }}
  //       >
  //         <CircularProgress color="inherit" />
  //       </Backdrop>
  //       {/* <p
  //         className="classCenter centerVertical"
  //         style={{
  //           fontSize: "25px",
  //           fontWeight: "bold",
  //           color: "#01AF43",
  //           marginTop: "35vh",
  //         }}
  //       >
  //         در حال بارگذاری اطلاعات
  //       </p>
  //       <br />
  //       <p
  //         className="classCenter centerVertical"
  //         style={{ fontSize: "20px", color: "#1D4A87" }}
  //       >
  //         لطفا صبور باشید
  //       </p> */}
  //     </div>
  //   );
  // }
  let row: any;
  const classes = useStyles();
  const [selectedRow, setSelectedRow] = useState(undefined);
  const [currentPaginationInfo, setCurrentPaginationInfo] = React.useState(
    (): PaginationInfo => {
      let paginationInfo = new PaginationInfo();
      paginationInfo.pageNumber = 1;
      return paginationInfo;
    }
  );
  if (isLoading) {
    return null;
  }
  return (
    <div>
      <div id="screenView">
        {suppliersInfo ? (
          <>
            <HeaderInfo
              referenceKey={id}
              setFlagActionTab={setFlagActionTab}
              setActionTabData={setActionTabData}
              flagActionTabs={flagActionTabs}
              // setDataGetCoreInformation={setDataGetCoreInformation}
              setDataGetCoreInformation={setSuppliersInfo}
              dataGetCartableActions={dataGetCartableActions}
              setDataGetCartableActions={setDataGetCartableActions}
              getCartableAction={getCartableAction}
              findDetail={true}
              // showInstallmentComponent={showInstallmentComponent}
              // setDataGetInstallmentCheque={setDataGetInstallmentCheque}
              // requestDetail={dataGetCoreInformation?.loanRequestInfo}
              // requestDetail={suppliersInfo?.supplierStatusTitle}
              isCore={isCore}
              // printedData={dataGetCoreInformation}
              printedData={0}
              scheduleInstallmentData={dataGetInstallmentTable}
              setReload={setReload}
              // test={setDataGetInstallmentTable}
            />
            {/* <FacilityFileDetail
              requestDetail={dataGetCoreInformation?.loanRequestInfo}
              child={child}
              showInstallmentComponent={setShowInstallmentComponent}
              setFlagActionTab={setFlagActionTab}
              setDataGetInstallmentTable={setDataGetInstallmentTable}
              setDataGetInstallmentCheque={setDataGetInstallmentCheque}
              isCore={isCore}
            /> */}
          </>
        ) : (
          // <div className="spinner-container">
          //   <div className="loading-spinner"></div>
          //   <p>test</p>
          // </div>
          // <div className="content">
          <div className="load-wrapp classCenter"></div>
          // </div>
        )}
        {flagActionTabs && !showInstallmentComponent ? (
          <ActionTabs
            setFlagActionTab={setFlagActionTab}
            actionTabsData={actionTabsData}
            referenceKey={id}
            setDataGetCoreInformation={setDataGetCoreInformation}
            setDataGetCartableActions={setDataGetCartableActions}
            getCartableAction={getCartableAction}
            setReload={setReload}
          />
        ) : null}
        {/* {dataGetCoreInformation?.loanRequestInfo.customerNationalCode ? (
          <ParsLisver
            nationalCode={
              dataGetCoreInformation?.loanRequestInfo.customerNationalCode
            }
          />
        ) : null} */}
        <br />
        {/* {dataGetCoreInformation ? (
          showInstallmentComponent ? (
            <ScheduleInstallment
              data={dataGetInstallmentTable}
              setDataGetInstallmentTable={setDataGetInstallmentTable}
            />
          ) : (
            <TabsPanel panelTabs={dataGetCoreInformation} />
          )
        ) : null} */}
      </div>
      {suppliersInfo?.supplierStatus.toLocaleLowerCase() !==
      "waitforactivation" ? (
        <div>
          <div id="screenView" style={{ marginBottom: "20px" }}>
            <_detailPage
              id={id}
              requestDetail={suppliersInfo}
              reload={reload}
            />
          </div>

          {suppliersInfo?.supplierCredits.length! > 0 ? (
            <div className="cardTableBorder" style={{ height: "fit-content" }}>
              <Table
                style={{ background: "#fff", maxHeight: "55vh" }}
                className="boxScroll"
              >
                <Table
                  stickyHeader
                  aria-label="sticky table"
                  style={{ borderCollapse: "collapse" }}
                >
                  <TableHead
                    className="rowTHead"
                    style={{ paddingBottom: "10px" }}
                  >
                    <TableRow
                      classes={{ root: classes.select }}
                      className={`${classes} borderRight borderLeft`}
                      selected={selectedRow === 0}
                    >
                      <TableCell
                        className="rowTHead colorTitle textFont12 fontWeight"
                        align="right"
                      ></TableCell>
                      <TableCell
                        className="rowTHead colorTitle textFont12 fontWeight"
                        align="right"
                        style={{ width: "10vh", minWidth: "10vh" }}
                      >
                        #
                      </TableCell>
                      {/* <StarsIcon scale="scale(1.8) " style={{ color: "#1D4A87" }} /> */}
                      {columns.map((column) => (
                        <TableCell
                          className="rowTHead colorTitle textFont12 fontWeight noWrap"
                          key={column.id}
                          align="right"
                        >
                          {column.label}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <div style={{ width: "100%", height: "10px" }}></div>
                  <TableBody>
                    {suppliersInfo?.supplierCredits
                      ? suppliersInfo?.supplierCredits.map((row, rowIndex) => {
                          return (
                            <TableRow
                              // classes={{ root: classes.select }}
                              className={`${
                                rowIndex % 2 === 0
                                  ? "rowTBodyE  "
                                  : "rowTBodyO "
                              } ${classes} borderRight borderLeft cursorPointer noWrap`}
                              hover
                              role="checkbox"
                              tabIndex={-1}
                              // selected={selectedRow === rowIndex}
                            >
                              <TableCell className="textFont12" align="right">
                                {/* {row.isInUserCartable ? (
                            <EmojiObjectsIcon
                              style={{ color: "#fbc02d", fontSize: "25px" }}
                            />
                          ) : (
                            <EmojiObjectsOutlinedIcon
                              style={{ color: "#C1C7CB", fontSize: "25px" }}
                            />
                          )} */}
                              </TableCell>
                              <TableCell
                                className="textFont12"
                                style={{ width: "10vh", minWidth: "10vh" }}
                              >
                                {((currentPaginationInfo.pageNumber ?? 0) - 1) *
                                  (currentPaginationInfo.pageSize! ?? 0) +
                                  rowIndex +
                                  1}
                              </TableCell>
                              {columns.map((column) => {
                                const value =
                                  row[column.id as keyof supplierCredits];
                                return (
                                  <TableCell
                                    className="textFont12"
                                    key={column.id}
                                    align="right"
                                  >
                                    {column.format && column.hasFormat
                                      ? column.format(value)
                                      : value?.toString()}
                                  </TableCell>
                                );
                              })}

                              {/* <TableCell className="textFont12" align="right">
                          <span
                            className={
                              "badge " +
                              (row.supplierSettlementStatusColor
                                ? row.supplierSettlementStatusColor ===
                                  "GreenLable"
                                  ? "badge-success"
                                  : "badge-danger"
                                : "badge-light")
                            }
                          >
                            {row.supplierSettlementStatusTitle}
                          </span>
                        </TableCell> */}
                            </TableRow>
                          );
                        })
                      : null}
                  </TableBody>
                </Table>
              </Table>
            </div>
          ) : null
          // <div>
          //   <img
          //     className="classCenter"
          //     style={{ width: "30%", margin: "auto", marginTop: "5vh" }}
          //     src="images/empthuCartable.png"
          //     alt=""
          //   />
          // </div>
          }
        </div>
      ) : (
        <div>
          <div id="screenView" style={{ marginBottom: "20px" }}>
            <_detailPage
              id={id}
              requestDetail={suppliersInfo}
              reload={reload}
            />
          </div>

          {suppliersInfo?.supplierUsers.length! > 0 ? (
            <div className="cardTableBorder" style={{ height: "fit-content" }}>
              <Table
                style={{ background: "#fff", maxHeight: "55vh" }}
                className="boxScroll"
              >
                <Table
                  stickyHeader
                  aria-label="sticky table"
                  style={{ borderCollapse: "collapse" }}
                >
                  <TableHead
                    className="rowTHead"
                    style={{ paddingBottom: "10px" }}
                  >
                    <TableRow
                      classes={{ root: classes.select }}
                      className={`${classes} borderRight borderLeft`}
                      selected={selectedRow === 0}
                    >
                      <TableCell
                        className="rowTHead colorTitle textFont12 fontWeight"
                        align="right"
                      ></TableCell>
                      <TableCell
                        className="rowTHead colorTitle textFont12 fontWeight"
                        align="right"
                        style={{ width: "10vh", minWidth: "10vh" }}
                      >
                        #
                      </TableCell>
                      {/* <StarsIcon scale="scale(1.8) " style={{ color: "#1D4A87" }} /> */}
                      {columnsActivation.map((column) => (
                        <TableCell
                          className="rowTHead colorTitle textFont12 fontWeight noWrap"
                          key={column.id}
                          align="right"
                        >
                          {column.label}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <div style={{ width: "100%", height: "10px" }}></div>
                  <TableBody>
                    {suppliersInfo?.supplierUsers
                      ? suppliersInfo?.supplierUsers.map((row, rowIndex) => {
                          return (
                            <TableRow
                              // classes={{ root: classes.select }}
                              className={`${
                                rowIndex % 2 === 0
                                  ? "rowTBodyE  "
                                  : "rowTBodyO "
                              } ${classes} borderRight borderLeft cursorPointer noWrap`}
                              hover
                              role="checkbox"
                              tabIndex={-1}
                              // selected={selectedRow === rowIndex}
                            >
                              <TableCell className="textFont12" align="right">
                                {/* {row.isInUserCartable ? (
                            <EmojiObjectsIcon
                              style={{ color: "#fbc02d", fontSize: "25px" }}
                            />
                          ) : (
                            <EmojiObjectsOutlinedIcon
                              style={{ color: "#C1C7CB", fontSize: "25px" }}
                            />
                          )} */}
                              </TableCell>
                              <TableCell
                                className="textFont12"
                                style={{ width: "10vh", minWidth: "10vh" }}
                              >
                                {((currentPaginationInfo.pageNumber ?? 0) - 1) *
                                  (currentPaginationInfo.pageSize! ?? 0) +
                                  rowIndex +
                                  1}
                              </TableCell>
                              {columnsActivation.map((column) => {
                                const value =
                                  row[column.id as keyof supplierUsers];
                                if (column.id === "isSuperUser")
                                  return value === true ? (
                                    <TableCell
                                      className="textFont12"
                                      key={column.id}
                                      align="right"
                                    >
                                      <CheckIcon color={"success"} />
                                    </TableCell>
                                  ) : (
                                    <TableCell
                                      className="textFont12"
                                      key={column.id}
                                      align="right"
                                    ></TableCell>
                                  );
                                return (
                                  <TableCell
                                    className="textFont12"
                                    key={column.id}
                                    align="right"
                                  >
                                    {column.format && column.hasFormat
                                      ? column.format(value)
                                      : value?.toString()}
                                  </TableCell>
                                );
                              })}

                              {/* <TableCell className="textFont12" align="right">
                          <span
                            className={
                              "badge " +
                              (row.supplierSettlementStatusColor
                                ? row.supplierSettlementStatusColor ===
                                  "GreenLable"
                                  ? "badge-success"
                                  : "badge-danger"
                                : "badge-light")
                            }
                          >
                            {row.supplierSettlementStatusTitle}
                          </span>
                        </TableCell> */}
                            </TableRow>
                          );
                        })
                      : null}
                  </TableBody>
                </Table>
              </Table>
            </div>
          ) : (
            <Table
              style={{ background: "#fff", maxHeight: "55vh" }}
              className="boxScroll"
            >
              <Table
                stickyHeader
                aria-label="sticky table"
                style={{ borderCollapse: "collapse" }}
              >
                <TableHead
                  className="rowTHead"
                  style={{ paddingBottom: "10px" }}
                >
                  <TableRow
                    classes={{ root: classes.select }}
                    className={`${classes} borderRight borderLeft`}
                    selected={selectedRow === 0}
                  >
                    <TableCell
                      className="rowTHead colorTitle textFont12 fontWeight"
                      align="right"
                    ></TableCell>
                    <TableCell
                      className="rowTHead colorTitle textFont12 fontWeight"
                      align="right"
                      style={{ width: "10vh", minWidth: "10vh" }}
                    >
                      #
                    </TableCell>
                    {/* <StarsIcon scale="scale(1.8) " style={{ color: "#1D4A87" }} /> */}
                    {columnsActivation.map((column) => (
                      <TableCell
                        className="rowTHead colorTitle textFont12 fontWeight noWrap"
                        key={column.id}
                        align="right"
                      >
                        {column.label}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <div style={{ width: "100%", height: "10px" }}></div>
                <TableBody>
                  {
                    <TableRow
                      // classes={{ root: classes.select }}
                      className={` ${classes} borderRight borderLeft cursorPointer noWrap`}
                      hover
                      role="checkbox"
                      tabIndex={-1}
                      style={{ height: "100px" }}
                      // selected={selectedRow === rowIndex}
                    >
                      <TableCell
                        className="textFont12"
                        align="right"
                      ></TableCell>
                      <TableCell
                        className="textFont12"
                        align="right"
                      ></TableCell>
                      <TableCell
                        className="textFont12"
                        align="right"
                      ></TableCell>
                      <TableCell
                        className="textFont12"
                        align="right"
                      ></TableCell>
                      <TableCell
                        className="textFont12"
                        align="right"
                        sx={{
                          color: "GrayText",
                          fontWeight: "bold",
                          fontSize: "3rem",
                        }}
                      >
                        رکوردی وجود ندارد
                      </TableCell>
                      <TableCell
                        className="textFont12"
                        align="right"
                      ></TableCell>
                      <TableCell
                        className="textFont12"
                        align="right"
                      ></TableCell>
                    </TableRow>
                  }
                </TableBody>
              </Table>
            </Table>
          )
          // <div>
          //   <img
          //     className="classCenter"
          //     style={{ width: "30%", margin: "auto", marginTop: "5vh" }}
          //     src="images/empthuCartable.png"
          //     alt=""
          //   />
          // </div>
          }
        </div>
      )}
    </div>
  );
}
interface DetailPagePropsInterface {
  cartable: any;
}
const mapStateToProps = ({ cartable }: DetailPagePropsInterface) => {
  return {
    cartable,
  };
};

export default withRouter(
  connect(mapStateToProps)(SuppliersRequirementsDetail)
);
